const HEGIAS_EMAIL_SUFFIX = "@hegias.com";

/**
 * Does this account hold a HEGIAS staff email address?
 *
 * The client-side mirror of `isHegiasStaff` in
 * `hegiasGo/server/v3/auth/hegiasStaff.js`. `profile.email` is an array and its
 * entries can be null, which is exactly why the server keeps this in one place
 * rather than letting each caller write the filter slightly differently — the
 * same reasoning applies here now that two call sites need it.
 *
 * **This decides rendering only.** Every endpoint behind it re-checks
 * server-side with `requireHegiasEmployee`, which reads the database rather than
 * trusting anything the client says. Editing a cookie gets you a menu entry and
 * a page that answers 403 to everything it asks for.
 */
const isHegiasStaffEmail = (emails?: Array<string | null>): boolean =>
	Array.isArray(emails) &&
	emails.some(
		(email) =>
			typeof email === "string" &&
			email.toLowerCase().endsWith(HEGIAS_EMAIL_SUFFIX),
	);

export default isHegiasStaffEmail;
